import React, { useState } from 'react';
import jet, { useDrag, useDrift, usePromise } from "@randajan/jet-react";

import "./FootPane.scss";
import { usePageContact } from '../../assets/hooks/usePageContact';
import { useBeam } from '@randajan/bifrost/client/react';
import { linksBeam } from '../../assets/beams/linksBeam';
import { WebLink } from '../../elements/WebLink/WebLink';
import { ContactPane } from './ContactPane/ContactPane';
import { SocialLinks } from './SocialLinks/SocialLinks';


const _undragableStart = new Set(["SPAN", "A", "H1", "H2", "H3", "H4", "H5", "H6"]);

const allowSwipe = (bound)=>{
    const dr = (bound.dist / bound.parent.height * 100 / 7); //100 = FULLY OPE
    if (dr < 1) { return bound?.event?.target?.tagName !== "IMG"; }
    if (dr > 40) { return true; }

    const speedRatio = dr / bound.time * 1000;
    if (speedRatio > 80) { return true; }
}

export const FootPane = ()=>{
    const { data:links } = useBeam(linksBeam);

    const [ isOpen, setOpen ] = usePageContact();

    const [ ref, move ] = useDrag((bound, id)=>{
        const target = bound?.event?.target;

        if (bound.state === "start") {
            if (!isOpen && _undragableStart.has(target?.tagName)) { bound.stop(); }
            const cn = target?.className;
            if (isOpen && (cn !== "mist" && cn !== "handle slab")) { bound.stop(); }
        }

        if (id !== bound.id) { return; }
        bound.relY = Number.jet.frame(bound.relY, -3, 4);
        if (bound.state !== "stop" || !bound.event) { return; }

        if (allowSwipe(bound)) { setOpen(!isOpen); }

    }, {
        initX:.5,
        initY:isOpen ? -3 : 4,
        up:.66,
        left:0,
        right:0,
        down:.66,
        autoReset:true,
        appendState:true,
    });

    return (
        <div className={jet.melt(["FootPane", isOpen ? "isOpen" : "isClosed"], " ")}>
            <div className="dragable" ref={ref}>
                <div className="mist"/>
                <SocialLinks className="handle slab">
                    {links?.filter(l=>l.category === "socials").map((link, key)=><WebLink key={key} link={link} short/>)}
                </SocialLinks>
                <div className="content">
                    <ContactPane links={links}/>
                </div>
            </div>
        </div>
    )
}

export default FootPane;
